import { Ng2StateDeclaration } from '@uirouter/angular';
import { ClusterEditComponent } from '@fi-app/cluster/cluster-edit/cluster-edit.component';
import { ClusterService } from '@fi-app/cluster/cluster.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiClusterStateResolvePageTitle } from '@fi-app/cluster/states/resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiClusterAddState: Ng2StateDeclaration = {
    name: FiStateNames.Cluster.Add,
    url: '/Add',
    views: {
        '@': {
            component: ClusterEditComponent,
        },
    },
    resolve: {
        cluster: [ClusterService, ContentLanguagesService, FiAddClusterStateResolve_cluster],
        pageTitle: FiClusterStateResolvePageTitle,
    },
};

export function FiAddClusterStateResolve_cluster(ClusterService, ContentLanguagesService) {
    return ClusterService.GetCluster(0, ContentLanguagesService.GetContentLanguages());
}
